import HybridLedgerComponent from '@/components/HybridLedger';

export default function HybridLedger() {
  return (
    <div className="space-y-6">
      <h1 className="text-xl sm:text-2xl font-bold tracking-tight">Review Video Submissions</h1>
      <HybridLedgerComponent />
    </div>
  );
}
